import { Loader } from "rsuite";

import { useModal } from "../../context/modal-context";

/**
 * AccountEditModal - Gabarit commun des modales d'édition de "Mon compte"
 *
 * Props:
 *   icon           — média { path, alt } affiché dans la pastille à gauche du titre
 *   title          — titre de la modale
 *   onSubmit       — handler de soumission du formulaire
 *   submitDisabled — désactive le bouton "Valider"
 *   loading        — affiche un loader dans le bouton "Valider"
 *   children       — contenu du formulaire
 */
export default function AccountEditModal({
  icon,
  title,
  onSubmit,
  submitDisabled,
  loading,
  children,
}) {
  const { hideModal } = useModal();

  return (
    <div className="w-[588px] max-w-full">
      {/* Header */}
      <div className="flex items-center gap-3 px-6 pt-[22px]">
        <span className="flex items-center justify-center flex-shrink-0 w-[27px] h-[26px] rounded-md bg-[#E2EAF1]">
          <img src={icon.path} alt={icon.alt} />
        </span>
        <h2 className="flex-1 text-lg font-semibold border-b text-neutral-dark border-neutral-lighter">
          {title}
        </h2>
      </div>

      <form onSubmit={onSubmit} className="flex flex-col gap-4 px-6 py-4">
        {children}

        {/* Séparateur + Boutons */}
        <div className="flex justify-between gap-3 pt-4 border-t border-neutral-lighter">
          <button
            type="button"
            onClick={hideModal}
            className="px-[12.5px] py-1.5 border border-primary text-primary rounded hover:bg-primary/5 transition-colors font-semibold"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={loading || submitDisabled}
            className="px-[12.5px] py-1.5 bg-primary text-white rounded hover:bg-primary/90 disabled:opacity-60 disabled:cursor-not-allowed transition-colors font-semibold"
          >
            {loading ? <Loader /> : "Valider"}
          </button>
        </div>
      </form>
    </div>
  );
}
